// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"867":"01f15f","930":"57a2bc"}[chunkId] + ".js";
};